module.exports = __webpack_public_path__ + "static/media/whack_preview.8823b8ee.png";